import axios from "axios";

const instance = axios.create({
  baseURL: "https://speak.lam-kprs.id/api",
});

export default instance;
